<template>
  <div id="non-essential-needs-calculator">
    <div class="row">
      <div class="col s12">
        <div class="card" v-for="(item, index) in listItems" :key="item.key">
          <div class="card-content row no-margins">
            <div class="col s12">
              <div class="item-title left">
                {{ item.name }}
              </div>
              <button v-if="item.isNew" class="btn-floating transparent btn-flat waves-effect right"
                @click="$_deleteAppliance(index)">
                <i class="material-icons grey-text text-darken-3">delete</i>
              </button>
              <div class="clear"></div>
            </div>
            <div class="col s12">
              <p>
                <label>
                  <input :disabled="userRole === 'subscriber'" type="checkbox" class="filled-in" v-model="item.isPresent"
                    @input="
                      $_calculateTotal(
                        $event,
                        index,
                        item.multiplier,
                        'isPresent'
                      )
                      " true-value="yes" false-value="no" name="" id="" />
                  <span>Is the appliance present at home?</span>
                </label>
              </p>
            </div>

            <div class="col s7 no-padding">
              <div class="col s5" v-if="!item.isNew">
                <div :id="`${item.key}_appliance_present`" class="select-title">
                  Avg. Household Use
                </div>
                <input :id="`${item.key}_house_use`" type="number" min="0" placeholder="0" v-model="item.houseUse"
                  class="validate" :disabled="(item.isPresent === 'yes' ? false : true) || userRole === 'subscriber'"
                  @input="$_calculateTotal($event, index, item.multiplier)" />
                <span class="helper-text">
                  <span v-if="item.key === 'clothes_washer'"> Loads/week</span>
                  <span v-if="item.key === 'dish_washer'">Cycles/day</span>
                </span>
                <!--  <label :for="`${key}_house_use`"></label> -->
              </div>

              <div v-if="item.waterConOptions" class="col s7">
                <div :class="`${item.key}_water_use select-title`">
                  Water Consumption Per Use (gallons/load)
                </div>

                <select :id="`${item.key}_water_use`" class="browser-default" v-model="item.waterConsumptionUse"
                  :disabled="(item.isPresent === 'yes' ? false : true) || userRole === 'subscriber'"
                  @change="$_calculateTotal($event, index, item.multiplier)">
                  <option value="" disabled>Select from dropdown list</option>
                  <option :value="opt.value" v-for="(opt, i) in item.waterConOptions" :key="i">
                    {{ opt.text }}
                  </option>
                </select>
                <div class="input-field" @input="$_calculateTotal($event, index, item.multiplier)"
                  v-if="item.waterConsumptionUse === 0">
                  <input :disabled="userRole === 'subscriber'" type="number" name=""
                    v-model="item.other_waterConsumptionUse" id="" />
                </div>
              </div>

              <div v-else :class="!item.isNew ? 'col s7' : 'col s12'">
                <div class="select-title" v-if="!item.isNew">
                  Water Consumption Per Use (gallons/cycle)
                </div>
                <div :class="`${item.key}_water_use select-title`" v-else>
                  Enter Total Consumption (gallons)
                </div>
                <input :id="`${item.key}_water_use`" type="number" min="0" v-model="listItems[index].waterConsumptionUse"
                  placeholder="0" class="validate" :disabled="(listItems[index].isPresent === 'yes' ? false : true) || userRole === 'subscriber'
                    " @input="$_calculateTotal($event, index, item.multiplier)" />
              </div>
            </div>
            <div class="col s5">
              <div class="select-title right-align">
                Total Water Consumption for 2 weeks
              </div>
              <div class="results-value right-align">
                {{ listItems[index].totalConsumption }} gallons
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col s12">
        <div class="sub-total">Subtotal</div>
        <div class="total-value">{{ subTotalX }} gallons</div>
      </div>
    </div>

    <div class="modal" ref="modal">
      <div class="modal-content">
        <div class="row" style="position: relative">
          <div class="col s12">
            <div class="modal-title">Add New Appliances</div>
          </div>
          <div class="input-field col s12">
            <input type="text" id="other_appliance" v-model="newAppliance" placeholder="Enter appliance" />
          </div>
          <div class="col s12">
            <button style="width: 100%" class="btn waves-effect indigo accent-3 modal-close close-modal"
              :disabled="!newAppliance || userRole === 'subscriber'" @click="$_addAppliance()">
              Add Appliance
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";

import { mapState } from 'vuex'
export default {
  name: "NonEssentialNeedsCalculator",
  props: {
    dataValue: {
      type: [Object, Array],
      default: () => { },
    },
  },
  data() {
    return {
      modal: {
        instance: null,
        options: {
          endingTop: "40%",
          onCloseEnd: () => {
            this.modal.instance.destroy();
            this.modal.instance = null;
          },
        },
      },
      newAppliance: "",
      listItems: [
        {
          key: "clothes_washer",
          name: "Clothes Washer",
          isPresent: "no",
          houseUse: "",
          multiplier: 2,
          waterConsumptionUse: "",
          other_waterConsumptionUse: "",
          waterConOptions: [
            {
              text: "Standard top-load washer - 30 to 45 gallons/load",
              value: 45,
            },
            {
              text: "Top-load high-efficiency machines - 12 to 17 gallons/load",
              value: 17,
            },
            {
              text: "Front-load washers - approx. 13 gallons/load",
              value: 13,
            },
            {
              text: "Other – enter your own value (gallons/load)",
              value: 0,
            },
          ],
          totalConsumption: 0,
          isNew: false,
        },
        {
          key: "dish_washer",
          name: "Dishwasher",
          isPresent: "no",
          houseUse: "",
          multiplier: 14,
          waterConsumptionUse: 8,
          other_waterConsumptionUse: "",
          waterConOptions: false,
          totalConsumption: 0,
          isNew: false,
        },
      ],
      nonEssentials: {
        clothes_washer: {
          name: "Clothes Washer",
          isPresent: "yes",
          houseUse: "",
          multiplier: 2,
          waterConsumptionUse: "",
          other_waterConsumptionUse: "",
          waterConOptions: [
            {
              text: "Standard top-load washer - 30 to 45 gallons/load",
              value: 45,
            },
            {
              text: "Top-load high-efficiency machines - 12 to 17 gallons/load",
              value: 17,
            },
            {
              text: "Front-load washers - approx. 13 gallons/load",
              value: 13,
            },
          ],
          totalConsumption: 0,
          isNew: false,
        },
        dish_washer: {
          name: "Dishwasher",
          isPresent: "yes",
          houseUse: "",
          multiplier: 14,
          waterConsumptionUse: 8,
          other_waterConsumptionUse: "",
          waterConOptions: false,
          totalConsumption: 0,
          isNew: false,
        },
      },
    };
  },
  mounted() {
    this.updateTextFields();
    this.$_getData();
    this.$emit("update", this.formDataX);
  },
  beforeDestroy() { },
  watch: {
    subTotalX() {
      this.$emit("update", this.formDataX);
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.User.user,
    }),
    userRole: {
      get() {
        return 'user'
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      }
    },
    subTotalX() {
      const value = this.listItems.reduce((result, item) => {
        result = parseFloat(result) + parseFloat(item.totalConsumption);
        return result;
      }, 0);

      return value;
    },
    formDataX() {
      return {
        ...this.listItems, //this.nonEssentials,
        subTotal: this.subTotalX,
      };
    },
  },
  methods: {
    updateTextFields() {
      setTimeout(() => {
        M.updateTextFields();
      });
    },
    $_openModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      setTimeout(() => {
        this.modal.instance.open();
      }, 150);
    },
    $_getData() {
      if (this.dataValue && Object.keys(this.dataValue).length > 0) {
        let newObj = { ...this.dataValue };
        delete newObj.subTotal;
        this.listItems = [...Object.values(newObj)];
      }
    },
    $_deleteAppliance(key) {
      this.$delete(this.listItems, key);
      this.$emit("update", this.formDataX);
    },
    $_addAppliance() {
      if (!this.newAppliance) return;

      // Object structure
      let newAppl = {
        name: this.newAppliance,
        isPresent: "yes",
        houseUse: 1,
        multiplier: 1,
        waterConsumptionUse: "",
        waterConOptions: false,
        totalConsumption: 0,
        isNew: true,
      };

      const generateKeyFromName = (name) => {
        // Replace all any non-alphanumeric character and white space with underscores
        let value = name.replace(/[\W_]/g, "_");

        // Remove any double underscores
        value = value.replace(/_+/g, "_");

        return value.toLowerCase();
      };

      // Create an appliance key
      const applKey = generateKeyFromName(newAppl.name);

      // Add new appliance to non essentials list
      this.listItems.push({ key: applKey, ...newAppl });
      /// this.$set(this.nonEssentials, applKey, newAppl);

      // Clear new appliance text
      this.newAppliance = "";

      // Update text flieds
      this.updateTextFields();

      // Save data
      // this.saveGetData("save");
    },
    $_calculateTotal({ target: { checked } }, key, multiplier, prop = null) {
      // Is this select essential need not present?
      if (prop === "isPresent" && !checked) {
        this.$set(this.listItems[key], "totalConsumption", 0);
        return;
      }
      // Get values to be multiplied
      const homeUse = parseFloat(this.listItems[key].houseUse) || 0;
      let waterConUse =
        parseFloat(this.listItems[key].waterConsumptionUse) || 0;
      this.listItems[key].waterConsumptionUse === 0
        ? (waterConUse = parseFloat(
          this.listItems[key].other_waterConsumptionUse
        ))
        : "";
      // Calculate and set total consumption for selected non essential need
      const totalCon = homeUse * waterConUse * multiplier;

      this.$set(this.listItems[key], "totalConsumption", totalCon);
    },
  },
};
</script>

<style scoped lang="scss">
#non-essential-needs-calculator {
  .select-title {
    padding-right: 12px;
    font-size: 14px;
    margin: 8px 0px 4px;
    letter-spacing: 0.5px;
  }

  .helper-text {
    font-size: 13px;
    letter-spacing: 1px;
  }
}

.results-value {
  font-size: 24px;
  text-align: right;
}

select {
  .browser-default {
    display: block;
    height: 46px;
  }
}

.modal {
  border-radius: 8px;
  max-width: 500px;
  margin: auto;

  .modal-content {}
}

.sub-total {
  font-size: 26px;
  float: left;
  padding: 0 8px;
}

.total-value {
  font-size: 28px;
  float: right;
  padding: 0px 14px;
}
</style>
<style lang="scss">
#non-essential-needs-calculator {
  .item-title {
    font-size: 20px;
    margin-bottom: 6px;
  }

  input {
    margin-bottom: 0px !important;
  }

  [type="checkbox"]+span:not(.lever) {
    padding-left: 30px;
    line-height: 20px;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}
</style>
